export function formatPrice(
  value: number | null | undefined,
  currencyFormat: Intl.NumberFormat
) {
  if (value === undefined || value === null) {
    return "";
  }
  return currencyFormat.format(value);
}
